<template>
  <div class="wrapper" id="default-wrapper">
    <div id="player"></div>
    <BaseFormLoading :loading="loading"></BaseFormLoading>
  </div>
</template>
<script>

import BaseFormLoading from './base/BaseFormLoading'

export default {
  name: 'Default',
  components: {BaseFormLoading},
  data: function () {
    return {
      loading: false,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.onYouTubeIframeAPIReady();
  },
  methods: {
    onYouTubeIframeAPIReady() {
      this.player = new YT.Player('player', {
        videoId: 'rIXhXaQ8tiM',
        playerVars: {
          autoplay: 1,
          // 'playsinline': 1,
          rel: 0,
          showinfo: 0,
          playlist: 'rIXhXaQ8tiM',
          loop: 1,
          mute: 0,
          modestbranding: 1,
          controls: 0,
          disablekb: 1
        },
        events: {
          'onReady': this.onPlayerReady,
          'onStateChange': this.onPlayerStateChange,
          'onError': this.onPlayerError
        }
      });
    },
    onPlayerReady(event) {
      event.target.playVideo();
    },
    onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING) {
      }
    },
    onPlayerError(event) {
      alert(event)
    }
  },
  watch: {}
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>
<style>
#default-wrapper, #default-wrapper iframe {
  width: 100%;
  height: 100vh;
}

#default-wrapper {
  overflow: hidden;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Default.vue